import styled from "styled-components/macro";

const Wrapper = styled.div`
  .symbol,
  .date {
    font-weight: 400;
    text-align: left;
    font-style: normal;
    letter-spacing: normal;
    line-height: normal;
  }

  .symbol {
    color: #333333;
    font-family: "Legacy Serif ITC Pro - Book";
    font-size: 20px;
    line-height: 22px;

    margin: 0;
  }

  .date {
    color: #333333;
    font-family: "Legacy Serif ITC Pro - Book";
    font-size: 16px;
    text-transform: uppercase;

    margin: 5px 0 0 0;
  }

  @media screen and (min-width: 993px) {
    .symbol {
      font-size: 26px;
      line-height: 28px;
    }

    .date {
      margin: 10px 0 0 0;
    }
  }

  @media screen and (min-width: 1241px) {
    .symbol {
      font-size: 40px;
      line-height: 44px;
    }

    .date {
      margin: 20px 0 0 0;
    }
  }

  @media screen and (min-width: 768px) and (max-width: 992px) {
    .symbol {
      font-size: 40px;
      line-height: 44px;
    }

    .date {
      margin: 20px 0 0 0;
    }
  }
`;

export default function StockInfo({ date, time, lang = "de" }) {
  let translatedTitle = "Swiss Life Aktie";
  if (lang === "en") {
    translatedTitle = "Swiss Life share";
  }

  return (
    <Wrapper>
      <h3 className="symbol">{translatedTitle}</h3>
      <h4 className="date">
        {date} {time}
      </h4>
    </Wrapper>
  );
}
